import Env from './env';

export default function () {
  if (Env.container === 'webview') {
    return {
      iOS: 3,
      Android: 4,
      'Windows Phone': 2,
      unknown: 2,
    }[Env.platform];
  }
  if (Env.platform !== 'unknown') {
    return 2; // H5
  }
  return 1; // PC
}



// WEBPACK FOOTER //
// ./src/utils/clientType.js